/**
 * DocumentEvents are events that are emitted by the DocumentStore class.
 */
export enum DocumentEvents {
    CHANGED = 'changed',
}
